import React from 'react'
import { Link } from 'react-router-dom'

export const Footer = () => {
  return (
    <footer className='pie'>
        &copy; Portafolio Daniel Urbano Luna
    </footer>
  )
}
